<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading">
      <div class="row">
        <button
          id="prev_pol_od_cov_details_renewal"
          type="button"
          class="expand-form-button"
          data-toggle="collapse"
          aria-label="Expand Journey Details"
          data-target="#previousPolicyODCoverDetails"
        >
          <img alt="Toggle Customer Details" src="@/assets/images/arr-up.png" />
        </button>
        <div class="col-10 p-0">
          <h3 class="pre-policyOD">Previous Policy OD Cover Details</h3>
        </div>
      </div>
    </div>
    <div class="collapse show col-12 bgc-form-box" id="previousPolicyODCoverDetails">
      <!-- Previous Policy Number starts-->
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          
          <float-label
            :fixed="isFloat(previousPolicyODCoverDetailsData.previousPolicyNumber.value)"
          >
            <input
              type="text"
              class="form-control"
              v-model="previousPolicyODCoverDetailsData.previousPolicyNumber.value"
              :class="{ 'bgc-error-field': previousPolicyODCoverDetailsData.previousPolicyNumber.errorText!=='' }"
              placeholder="Previous Policy Number"
              v-evolvews="previousPolicyODCoverDetailsData.previousPolicyNumber"
            />
          </float-label>
          <span
            class="error-text"
            v-if="previousPolicyODCoverDetailsData.previousPolicyNumber.errorText!==''"
          >{{ previousPolicyODCoverDetailsData.previousPolicyNumber.errorText}}</span>
        </div>
        <!-- Previous Policy Number end-->
        <!-- Previous Company Name starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="Previous Company Name"
            :fixed="isFloat(previousPolicyODCoverDetailsData.previousCompanyName.value)"
          >
            <select
              class="form-control"
              v-model="previousPolicyODCoverDetailsData.previousCompanyName.value"
            >
              <option disabled value>Previous Company Name</option>
              <option>Select</option>
            </select>
          </float-label>
          </div>
        </div>
        <!-- Previous Company Name end-->
        <!-- Previous Company Address starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            :fixed="isFloat(previousPolicyODCoverDetailsData.previousCompanyAddress.value)"
          >
            <input
              type="text"
              class="form-control"
              v-model="previousPolicyODCoverDetailsData.previousCompanyAddress.value"
              placeholder="Previous Company Address"
            />
          </float-label>
          </div>
        </div>
        <!-- Previous Company Address end-->
        <div class="col-lg-3 col-md-3 col-sm-6 blank-div"></div>
        <!-- TP Policy Start Date starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="TP Policy Start Date"
            :fixed="isFloat(previousPolicyODCoverDetailsData.tpPolicyStartDate.value)"
          >
            <datepicker
              format="dd/MM/yyyy"
              :typeable="true"
              v-model="previousPolicyODCoverDetailsData.tpPolicyStartDate.value"
              input-class="bgc-input form-control bgc-calendar-icon labelMargin"
              placeholder="TP Policy Start Date"
            ></datepicker>
          </float-label>
          </div>
        </div>
        <!-- TP Policy Start Date end-->
        <!-- Previous Policy Expiry Date starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="Previous Policy Expiry Date"
            :fixed="isFloat(previousPolicyODCoverDetailsData.previousPolicyExpiryDate.value)"
          >
            <datepicker
              format="dd/MM/yyyy"
              :typeable="true"
              v-model="previousPolicyODCoverDetailsData.previousPolicyExpiryDate.value"
              input-class="bgc-input form-control bgc-calendar-icon labelMargin"
              placeholder="Previous Policy Expiry Date"
            ></datepicker>
          </float-label>
          </div>
        </div>
        <!-- Previous Policy Expiry Date end-->
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import { reactive } from '@vue/composition-api';
export default {
  name: "PreviousPolicyODCoverDetails",
  props: ["previousPolicyODCoverDetailsData"],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props){
    let state = reactive({
    });
    //methods
    const checkError= functions.checkError;
    const isFloat= functions.isFloat;
    const isInputError= functions.isInputError;
    //return
    return{
      checkError,
      isFloat,
      isInputError
    }
  },
  directives: {
    evolvews: functions.evolvews,
  }
};
</script>
<style scoped>
@media (max-width: 767px) {
  .blank-div {
    display: none;
  }
}
</style>